import { useEffect, useMemo } from "react"

import { SearchspringFetcher } from "@app/scripts/lib/searchspring"
import {
  OptionValue,
  useSearchspringContext,
} from "@app/scripts/providers/searchspring"
import { useSearchspringOptionsSync } from "./use-searchspring-options-sync"

type Options<Value extends OptionValue> = {
  defaultValue: Value
  syncWithURL?: boolean
}

// On load issue?
export function useSearchspringOption<
  Client extends SearchspringFetcher<Response>,
  Response,
  Value extends OptionValue,
>(key: string, _options: Options<Value> = { defaultValue: "" }) {
  const { defaultValue, syncWithURL = false } = _options

  const { options } = useSearchspringContext<Client, Response>()
  const { setOptionToURL, getOptionFromURL } = useSearchspringOptionsSync()

  const option = useMemo(() => {
    return (options.get(key) || defaultValue) as Value
  }, [options])

  useEffect(() => {
    if (syncWithURL) getOptionFromURL(key)
  }, [])

  useEffect(() => {
    if (syncWithURL) setOptionToURL(key)
  }, [option])

  return option || defaultValue
}
